module.exports = __webpack_public_path__ + "static/media/error-message.87224fed.svg";